<template>
    <div class="preparation-product-page col-md-12">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors">
            <div class="row mb-3 align-items-center">
                <div class="col-md-6 col-12">
                    <h2>Produit : {{ product.tiny_name }}</h2>
                </div>
                <div class="col-md-6 col-12">
                    <OrdersPreparationProgressBars
                        :pickup-points-productions-status="progressCounters['pickup_points_productions']"
                        :pickup-points-subcustomers-status="progressCounters['pickup_points_subcustomers']"
                        :short-channels-status="progressCounters['short_channels']"
                        :customer-groups-status="progressCounters['customer_groups']"
                        :stores-status="progressCounters['stores']"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h3>Production lieux de retrait</h3>
                </div>
            </div>

            <div class="row">
                <div v-if="pickupPointsProductionsOrders.length === 0" class="col-md-12">
                    <span class="nothing">
                        Aucune commande de production de lieu de retrait trouvée
                    </span>
                </div>
                <PreparationProduct
                    v-else
                    v-for="order in _.orderBy(pickupPointsProductionsOrders, ['name'])"
                    class="col-md-3 mb-3"
                    :key="order.id"
                    :order="order"
                    :product="product"
                    :preparation-status="order.preparation_status"
                    :inputs="order.inputs"
                    :cancellation-reasons="cancellationReasons"
                    :read-only="!order.ready_to_prepare"
                >
                    <div class="preparation-product-name">
                        <a :href="'/espace-employes/commandes/preparation/commande/' + order.id + '?from-product=' + product.sku">
                            {{ order.customer.name }}
                        </a>
                    </div>
                </PreparationProduct>
            </div>

            <div class="row mt-4">
                <div class="col-md-12">
                    <h3>Clients lieux de retrait</h3>
                </div>
            </div>

            <template v-if="Object.keys(pickupPointsSubcustomersOrders).length">
                <template v-for="pickupPoint in _.orderBy(_.values(pickupPointsSubcustomersOrders), ['name'])">
                    <div class="row mt-4">
                        <div class="col-md-12">
                            <h4>{{ pickupPoint.name }}</h4>
                        </div>
                    </div>

                    <div class="row">
                        <div v-if="pickupPoint.orders.length === 0" class="col-md-12">
                            <span class="h4">
                                Aucune commande client trouvée pour ce lieu de retrait
                            </span>
                        </div>
                        <PreparationProduct
                            v-for="order in pickupPoint.orders"
                            class="col-md-3 mb-3"
                            :key="order.id"
                            :order="order"
                            :product="product"
                            :preparation-status="order.preparation_status"
                            :inputs="order.inputs"
                            :cancellation-reasons="cancellationReasons"
                            :read-only="!order.ready_to_prepare"
                        >
                            <div class="preparation-product-name">
                                <a :href="'/espace-employes/commandes/preparation/commande/' + order.id + '?from-product=' + product.sku">
                                    {{ order.subcustomer.name }}
                                </a>
                            </div>
                        </PreparationProduct>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="nothing">
                    Aucune commande lieu de retrait trouvée
                </div>
            </template>

            <div class="row mt-4">
                <div class="col-md-12">
                    <h3>Circuits courts</h3>
                </div>
            </div>

            <div class="row">
                <div v-if="shortChannelsOrders.length === 0" class="col-md-12">
                    <span class="nothing">
                        Aucune commande circuit court trouvée
                    </span>
                </div>
                <PreparationProduct
                    v-else
                    v-for="order in _.orderBy(shortChannelsOrders, ['short_channel_name'])"
                    class="col-md-3 mb-3"
                    :key="order.id"
                    :order="order"
                    :product="product"
                    :preparation-status="order.preparation_status"
                    :inputs="order.inputs"
                    :cancellation-reasons="cancellationReasons"
                    :read-only="!order.ready_to_prepare"
                    :display-subcustomers="false"
                    :display-add-missing-products-modal="false"
                >
                    <div class="preparation-product-name">
                        <a :href="'/espace-employes/commandes/preparation/commande/' + order.id + '?from-product=' + product.sku">
                            {{ order.customer.name }}
                        </a>
                    </div>
                </PreparationProduct>
            </div>

            <div class="row mt-4">
                <div class="col-md-12">
                    <h3>Groupements de clients</h3>
                </div>
            </div>

            <div class="row">
                <div v-if="customerGroupsOrders.length === 0" class="col-md-12">
                    <span class="nothing">
                        Aucune commande groupement de clients trouvée
                    </span>
                </div>
                <PreparationProduct
                    v-else
                    v-for="order in _.orderBy(customerGroupsOrders, ['customer_group_name'])"
                    class="col-md-3 mb-3"
                    :key="order.id"
                    :order="order"
                    :product="product"
                    :preparation-status="order.preparation_status"
                    :inputs="order.inputs"
                    :cancellation-reasons="cancellationReasons"
                    :read-only="!order.ready_to_prepare"
                    :display-subcustomers="false"
                    :display-add-missing-products-modal="false"
                >
                    <div class="preparation-product-name">
                        <a :href="'/espace-employes/commandes/preparation/commande/' + order.id + '?from-product=' + product.sku">
                            {{ order.customer.name }}
                        </a>
                    </div>
                </PreparationProduct>
            </div>

            <div class="row mt-4">
                <div class="col-md-12">
                    <h3>Magasins</h3>
                </div>
            </div>

            <div class="row">
                <div v-if="storesOrders.length === 0" class="col-md-12">
                    <span class="nothing">
                        Aucune commande magasin trouvée
                    </span>
                </div>
                <PreparationProduct
                    v-else
                    v-for="order in _.orderBy(storesOrders, ['store_name'])"
                    class="col-md-3 mb-3"
                    :key="order.id"
                    :order="order"
                    :product="product"
                    :preparation-status="order.preparation_status"
                    :inputs="order.inputs"
                    :cancellation-reasons="cancellationReasons"
                    :read-only="!order.ready_to_prepare"
                >
                    <div class="preparation-product-name">
                        <a :href="'/espace-employes/commandes/preparation/commande/' + order.id + '?from-product=' + product.sku">
                            {{ order.customer.name }}
                        </a>
                    </div>
                </PreparationProduct>
            </div>
        </template>
    </div>
</template>

<script>
    import OrdersPreparationProgressBars from "./OrdersPreparationProgressBars";
    import PreparationProduct from "./PreparationProduct";
    import ErrorsZone from "../ErrorsZone";
    import LoadingScreen from "../LoadingScreen";

    import {useGetLoader} from "../compositions/axios/loadingRequest";
    import {momentDay} from "../../moment-with-helpers";

    export default {
        name: 'PreparationProductPage',

        components: {
            ErrorsZone,
            LoadingScreen,
            OrdersPreparationProgressBars,
            PreparationProduct,
        },

        props: {
            endPreparationDate: {
                type: String,
                required: true,
            },
            product: {
                type: Object,
                required: true,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                storesOrders: [],
                shortChannelsOrders: [],
                customerGroupsOrders: [],
                pickupPointsProductionsOrders: [],
                pickupPointsSubcustomersOrders: [],

                progressCounters: {},

                loadedOnce: false,

                cancellationReasons: [],
            };
        },

        created() {
            Echo.private(`employees`)
                .listen('OrderUpdatedEvent', (e) => {
                    if (momentDay(e.order.end_preparation_date).format('YYYY-MM-DD') === this.endPreparationDate) {
                        this.loadStateFromServer();
                    }
                });
        },

        async mounted() {
            this.loadStateFromServer();
        },

        methods: {
            async loadStateFromServer() {
                const data = await this.load(`/espace-employes/commandes/preparation/${this.endPreparationDate}/produit/${this.product.sku}/json`);
                if (data) {
                    this.storesOrders = data.storesOrders;
                    this.shortChannelsOrders = data.shortChannelsOrders;
                    this.customerGroupsOrders = data.customerGroupsOrders;
                    this.pickupPointsProductionsOrders = data.pickupPointsProductionsOrders;
                    this.pickupPointsSubcustomersOrders = data.pickupPointsSubcustomersOrders;
                    this.progressCounters = data.progressCounters;

                    this.cancellationReasons = data.cancellationReasons;

                    this.loadedOnce = true;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .preparation-product-page {
        .preparation-product-name {
            a {
                text-decoration: none;
                color: #212529;

                &:hover {
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
    }
</style>
